// extracted by mini-css-extract-plugin
module.exports = {"playback-speed":"AudioPlaybackSelect_playback-speed__1Qz4y","playback-speed-select":"AudioPlaybackSelect_playback-speed-select__3x3-W"};